import React from 'react'
import { MdContentCopy } from 'react-icons/md'
import { Tooltip, Notification, toast } from 'components/ui'
import PropTypes from 'prop-types'

const CopyButton = ({ text, tooltipTitle = 'Copy', successMessage = 'Copied', className }) => {
    const handleCopy = (e) => {
        e.stopPropagation()
        if (!text) return
        navigator.clipboard.writeText(text).then(() => {
            toast.push(
                <Notification title={'Success'} type="success" duration={2000}>
                    {successMessage}
                </Notification>,
                { placement: 'bottom-end' }
            )
        })
    }

    return (
        <Tooltip title={tooltipTitle}>
            <MdContentCopy
                className={`cursor-pointer text-gray-500 hover:text-blue-500 ${className || ''}`}
                onClick={handleCopy}
            />
        </Tooltip>
    )
}

CopyButton.propTypes = {
    text: PropTypes.string,
    tooltipTitle: PropTypes.string,
    successMessage: PropTypes.string,
    className: PropTypes.string
}

export default CopyButton
